import React from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { WHATSAPP_TEMPLATES } from "../../constants/whatsappTemplates";
import WhatsAppIcon from "./WhatsAppIcon";

/* Optional WhatsApp template picker used in every notification-send dialog.
   {{1}} (recipient name) is filled automatically by the backend; only the
   template's remaining params get an input here. */
type Props = {
    template: string;
    params: string[];
    onTemplateChange: (template: string) => void;
    onParamsChange: (params: string[]) => void;
};

const WhatsAppTemplateSection: React.FC<Props> = ({ template, params, onTemplateChange, onParamsChange }) => {
    const selected = WHATSAPP_TEMPLATES.find((t) => t.name === template);

    return (
        <div className="flex flex-col gap-2 border rounded p-3" style={{ borderColor: "#25D366" }}>
            <label className="text-sm font-medium flex items-center gap-2">
                <span style={{ color: "#25D366", display: "inline-flex" }}>
                    <WhatsAppIcon size={16} />
                </span>
                WhatsApp Template (optional)
            </label>

            <Dropdown
                value={template || null}
                options={WHATSAPP_TEMPLATES.map((t) => ({ label: t.label, value: t.name }))}
                onChange={(e) => {
                    const next = e.value || "";
                    onTemplateChange(next);
                    const count = WHATSAPP_TEMPLATES.find((t) => t.name === next)?.fields.length || 0;
                    onParamsChange(Array.from({ length: count }, (_, i) => params[i] || ""));
                }}
                placeholder="Select WhatsApp template"
                showClear
                className="w-full"
            />

            {selected && (
                <span className="text-xs" style={{ color: "#6b7280" }}>
                    Name (પ્રિય ...) is filled automatically for each user
                </span>
            )}

            {selected &&
                selected.fields.map((fieldLabel, i) => (
                    <div key={i} className="flex flex-col gap-1">
                        <label className="text-xs font-medium">{fieldLabel}</label>
                        <InputText
                            value={params[i] || ""}
                            onChange={(e) => {
                                const next = [...params];
                                next[i] = e.target.value;
                                onParamsChange(next);
                            }}
                            placeholder={fieldLabel}
                            className="w-full"
                        />
                    </div>
                ))}
        </div>
    );
};

export default WhatsAppTemplateSection;
